const initialState = {
	list: [],
	count: 0,
	countOpen: 0,
	page: 1,
	isListNext: false,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MY_QA_QUESTION_LIST_SET') {
		let newState = Object.assign({}, state);
		let list = action.payload.list;
		newState.list = list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.count = action.payload.count;
		newState.countOpen = action.payload.countOpen;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'MY_QA_QUESTION_LIST_INIT') {
		let newState = Object.assign({}, state);
		newState.datetime = null;
		return newState;
	}
	else if (action.type === 'MY_QA_QUESTION_ITEM_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((value) => value.qa_id === action.payload.qaId);
		if (index >= 0) {
			newState.list[index] = action.payload.qa;
		}
		else {
			newState.list.unshift(action.payload.qa);
		}
		return newState;
	}
	else if (action.type === 'MY_QA_QUESTION_STATISTICS_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((v) => v.qa_id === action.payload.qaId);

		if (index >= 0) {
			if (action.payload.type === 'add') {
				newState.list[index]['statistics'] = action.payload.list;
			}
			else if (action.payload.type === 'del') {
				delete newState.list[index]['statistics'];
			}
		}
		return newState;
	}
	else if (action.type === 'MY_QA_QUESTION_STATISTICS_USER_SET') {
		let newState = Object.assign({}, state);
		let listIndex = newState.list.findIndex((v) => v.qa_id === action.payload.qaId);

		if (listIndex >= 0) {
			let statisticsIndex = newState.list[listIndex]['statistics'].findIndex((v) => v.answer_comment === action.payload.answerText);
			if (statisticsIndex >= 0) {
				if (action.payload.type === 'add') {
					console.log(action.payload.list);
					newState.list[listIndex]['statistics'][statisticsIndex]['user'] = {
						list: action.payload.list,
						isListNext: action.payload.isListNext,
						page: action.payload.page,
					};
				}
				else if (action.payload.type === 'del') {
					delete newState.list[listIndex]['statistics'][statisticsIndex]['user'];
				}
			}
		}
		return newState;
	}
	else {
		return state;
	}
}
